import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { AddVideoEvent, All, LoadVideoEvents, RemoveVideoEvent, UpdateVideoEvent } from '../../actions/event'
import { ReplyApi, VideoEventApi } from '../../apis'
import { Event } from '../../models'
import { AppState } from '../../reducers'
import { EventService } from './base'

@Injectable()
export class VideoEventService extends EventService{
  protected LoadEvents(resourceId: number, events: Event[]): All {
    return new LoadVideoEvents(resourceId, events)
  }
  protected AddEvent(event: Event, enabledChatgpt?:boolean): All {
    return new AddVideoEvent(event, enabledChatgpt)
  }
  protected RemoveEvent(eventId: number): All {
    return new RemoveVideoEvent(eventId)
  }
  protected UpdateEvent(event: Event): All {
    return new UpdateVideoEvent(event)
  }
  constructor(protected api: VideoEventApi, protected replyApi:ReplyApi, protected store: Store<AppState>) {
    super(api, replyApi, store)
  }
}



// WEBPACK FOOTER //
// ./src/services/event/video.ts